"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppUsabilityError = exports.DatabaseError = exports.DatabaseVersionTableNotExistsError = exports.DatabaseVersionNotSetError = exports.DatabaseVersionChangeError = exports.ServerError = exports.ServiceError = exports.NetworkError = exports.ValidationError = void 0;
// The `captureStackTrace` is a non-standard V8 function that creates the stack property on an Error instance.
// Though it is a V8 function it is also available on newer Safari browsers too,
// but we have to check it's availability, and declare as an empty function if its not defined.
if (typeof Error.captureStackTrace === 'undefined') {
    Error.captureStackTrace = () => { };
}
/**
 * ValidationError
 * @param data
 * @constructor
 */
function ValidationError(data) {
    this.message = data.message;
    this.name = 'ValidationError';
    this.severity = data.severity || 10;
    this.code = data.code;
    Error.captureStackTrace(this, ValidationError);
}
exports.ValidationError = ValidationError;
/**
 * NetworkError
 * @param data
 * @constructor
 */
function NetworkError(data) {
    this.message = data.message;
    this.name = 'NetworkError';
    this.severity = data.severity || 10;
    this.code = data.code;
    Error.captureStackTrace(this, NetworkError);
}
exports.NetworkError = NetworkError;
/**
 * ServerError
 * @param data
 * @constructor
 */
function ServiceError(data) {
    this.message = data.message;
    this.name = 'ServiceError';
    this.severity = data.severity || 10;
    this.code = data.code;
    Error.captureStackTrace(this, ServiceError);
}
exports.ServiceError = ServiceError;
/**
 * ServerError
 * @param data
 * @constructor
 */
function ServerError(data) {
    this.message = data.message;
    this.name = 'ServerError';
    this.severity = data.severity || 10;
    this.code = data.code;
    Error.captureStackTrace(this, ServerError);
}
exports.ServerError = ServerError;
/**
 * DatabaseError
 * @param data
 * @constructor
 */
function DatabaseVersionChangeError(data) {
    this.message = data.message;
    this.name = 'DatabaseVersionChangeError';
    this.severity = data.severity || 10;
    this.code = data.code;
    Error.captureStackTrace(this, DatabaseVersionChangeError);
}
exports.DatabaseVersionChangeError = DatabaseVersionChangeError;
/**
 * DatabaseError
 * @param data
 * @constructor
 */
function DatabaseVersionNotSetError(data) {
    this.message = data.message;
    this.name = 'DatabaseError';
    this.severity = data.severity || 10;
    this.code = data.code;
    Error.captureStackTrace(this, DatabaseVersionNotSetError);
}
exports.DatabaseVersionNotSetError = DatabaseVersionNotSetError;
/**
 * DatabaseError
 * @param data
 * @constructor
 */
function DatabaseVersionTableNotExistsError(data) {
    this.message = data.message;
    this.name = 'DatabaseError';
    this.severity = data.severity || 10;
    this.code = data.code;
    Error.captureStackTrace(this, DatabaseVersionTableNotExistsError);
}
exports.DatabaseVersionTableNotExistsError = DatabaseVersionTableNotExistsError;
/**
 * DatabaseError
 * @param data
 * @constructor
 */
function DatabaseError(data) {
    this.message = data.message;
    this.name = 'DatabaseError';
    this.severity = data.severity || 10;
    this.code = data.code;
    Error.captureStackTrace(this, DatabaseError);
}
exports.DatabaseError = DatabaseError;
/**
 * AppUsabilityError
 * @param data
 * @constructor
 */
function AppUsabilityError(data) {
    this.message = data.message;
    this.name = 'AppUsabilityError';
    this.severity = data.severity || 10;
    this.code = data.code;
    Error.captureStackTrace(this, AppUsabilityError);
}
exports.AppUsabilityError = AppUsabilityError;
ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;
ServerError.prototype = Object.create(Error.prototype);
ServerError.prototype.constructor = ServerError;
ServiceError.prototype = Object.create(Error.prototype);
ServiceError.prototype.constructor = ServiceError;
NetworkError.prototype = Object.create(Error.prototype);
NetworkError.prototype.constructor = NetworkError;
DatabaseVersionChangeError.prototype = Object.create(DatabaseError.prototype);
DatabaseVersionChangeError.prototype.constructor = DatabaseVersionChangeError;
DatabaseVersionNotSetError.prototype = Object.create(DatabaseError.prototype);
DatabaseVersionNotSetError.prototype.constructor = DatabaseVersionNotSetError;
DatabaseVersionTableNotExistsError.prototype = Object.create(DatabaseError.prototype);
DatabaseVersionTableNotExistsError.prototype.constructor = DatabaseVersionTableNotExistsError;
DatabaseError.prototype = Object.create(Error.prototype);
DatabaseError.prototype.constructor = DatabaseError;
AppUsabilityError.prototype = Object.create(Error.prototype);
AppUsabilityError.prototype.constructor = AppUsabilityError;
//# sourceMappingURL=../../src/index.js.map